module.exports = __webpack_public_path__ + "img/mercedes-class.0a9733f8.jpeg";